import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "./queryKeys.js";
import useSharedData from "../useSharedData.ts";

//** Axios request */
import { request } from "../../utilities/axios-utils.js";

//----------------------------------------------------------------

const checkForAnyFalseValues = (response) => {
  //** If any of the response values are true - Return true */
  //* {
  //*     "transactionServiceDisruption": false,
  //*    "paymentMethodServiceDisruption": false,
  //*     "clientTokenServiceDisruption": false,
  //*     "secureCoServiceDisruption": false
  //* }

  const gatewayStatus = response;

  return Object.values(gatewayStatus).some((value) => value === true);
};

const getCheckPaymentGatewayStatus = async (requestData, openErrorModal) => {
  const { jwtToken } = { ...requestData };

  const isDev = false;

  const tempAccessToken =
    "eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJodHRwczovL2Rldi5lbGlmZWluc3VyZS5jb20uYXUvb2F1dGgyL3Rva2VuIiwiaXNzIjoidGVybWxpZmUtYXBpLmRldiIsInN1YiI6InRlcm1saWZlLWFwaS5kZXYuand0IiwiaWF0IjoxNzA0OTcwNzQxLCJleHAiOjE3MDQ5OTk1NDEsImp0aSI6IjkzY2JkYzg5LTQzODktNDM4MC04Yjg4LTVmMTAwZGQwZTIyMiIsInFpZCI6IjYzNFFBMzQ1NzNBTFAiLCJlbHRpZCI6ImVmOGEzNzQyLTk3MjUtNGY1MC1iYTU4LWNkMDc2Y2Q3Nzk5OSIsIm9rdGFVc2VySWQiOiIwMHUzanN3Z3I2cjZVdlpKYzNsNyIsImNjX3VzZXIiOnRydWUsInVzZXJuYW1lIjoiamNxYiIsImZpcnN0TmFtZSI6IkNvbGluIiwibGFzdE5hbWUiOiJCeXJuZSJ9.Lrnq-Vmg1Aaau0EefOZRMamy2A6aSx1ADb1CHzekTAY";

  const jwtAccessToken = isDev === true ? tempAccessToken : jwtToken;

  const response = await request({
    url: "/apgStatus",
    method: "GET",
    accessToken: jwtAccessToken,
  });
  if (200 !== response.status) {
    openErrorModal();
    throw response;
  } else {
    let returnResponse = checkForAnyFalseValues(response.data);
    return returnResponse;
  }
};

export const useGetCheckPaymentGatewayStatus = (requestData) => {
  const { openErrorModal } = useSharedData();

  return useQuery({
    queryKey: [queryKeys.GET_CHECK_PAYMENT_GATEWAY_STATUS],
    queryFn: async () =>
      await getCheckPaymentGatewayStatus(requestData, openErrorModal),
    enabled: !!requestData?.jwtToken && requestData.enabled,
  });
};
